import { render, staticRenderFns } from "./TabletCharacterImage.vue?vue&type=template&id=5e258412&scoped=true&"
import script from "./TabletCharacterImage.vue?vue&type=script&lang=js&"
export * from "./TabletCharacterImage.vue?vue&type=script&lang=js&"
import style0 from "./TabletCharacterImage.vue?vue&type=style&index=0&id=5e258412&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e258412",
  null
  
)

export default component.exports